/* eslint no-console:0 */

import { dom, library } from "@fortawesome/fontawesome-svg-core";

import {
  faArrowRight,
  faArrowsAltH,
  faCalendar,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCog,
  faComments,
  faExclamationTriangle,
  faFolderOpen,
  faInfoCircle,
  faKey,
  faPencilAlt,
  faQuestionCircle,
  faSearch,
  faSignInAlt,
  faSignOutAlt,
  faTimes,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

import {
  faCreativeCommons,
} from "@fortawesome/free-brands-svg-icons";

library.add(
  faArrowRight,
  faArrowsAltH,
  faCalendar,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCog,
  faComments,
  faCreativeCommons,
  faExclamationTriangle,
  faFolderOpen,
  faInfoCircle,
  faKey,
  faPencilAlt,
  faQuestionCircle,
  faSearch,
  faSignInAlt,
  faSignOutAlt,
  faTimes,
  faUser,
);

dom.watch();
